import store from '../../store'
import {
    SUPER_ADMIN_SET_COMPANIES,
    SUPER_ADMIN_SET_LOCATIONS_IP,
    SUPER_ADMIN_SET_USERS,
} from '../super-admin'
import type {
    Company,
    LocationIP,
    User,
} from '../../types/domain'

/**
 * Set users into store
 */
export const setSuperAdminUsersAction = (users: User[]): void => {
    store.dispatch({
        type: SUPER_ADMIN_SET_USERS,
        users: users.filter(user => !(user?.hidden || false)),
    })
}

/**
 * Set companies into store
 */
export const setSuperAdminCompaniesAction = (companies: Company[]): void => {
    store.dispatch({
        type: SUPER_ADMIN_SET_COMPANIES,
        companies: companies,
    })
}

/**
 * Set locations ip into store
 */
export const setSuperAdminLocationsIpAction = (locationsIP: LocationIP[]): void => {
    store.dispatch({
        type: SUPER_ADMIN_SET_LOCATIONS_IP,
        locationsIP: locationsIP,
    })
}
